import { MetricBaseIcon } from '@tableau/icons/MetricBaseIcon';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { Messages } from '../../codegen/Localize';
import {
  ContentTypeFilterClause,
  MixedContentItemDefinition,
  SpaceDefinition
} from '../../spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';
import { ConnectedMetricCard } from '../components/ConnectedMetricCard';
import { Metrics } from '../resources/Metrics';
import { MetricContentType } from './MetricContentType';

export const MetricDefinition: MixedContentItemDefinition & SpaceDefinition<'metric'> = {
  itemType: 'metric',
  contentType: 'metric',
  pluralName: Messages.metrics,
  singularName: Messages.metric,
  emptyStateMessage: Messages.metricsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Metrics,
  contentFilterKeys: MetricContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: ConnectedMetricCard,
  listViewIconType: MetricBaseIcon,
  filterClause: ServerFilterClauses.ContentType(['metric']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.metricUrl(contentId),
  getBasicQuery: () => {
    return Metrics.all().withExtraParams(MetricContentType.extraQueryParams);
  },
  fieldValueResourceType: 'metric',
  getContentInfo: () => { },
  headerIconPath: undefined,
  supportedDisplayModes: ['list', 'thumbnail'],
};
